<script>
import { ScrollCarousel } from '@rei/recommendations-slider';
import { CdrBreakpointSm, CdrBreakpointMd, CdrBreakpointLg } from '@rei/cdr-tokens';
import headingSection from '../../../pages/home/components/headingSection/headingSection.vue';
import InfoCard from './InfoCard.vue';

export default {
  name: 'InfoCards',
  components: {
    InfoCard,
    headingSection,
    ScrollCarousel,
  },
  props: {
    heading: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    cards: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    visualConfiguration: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      ui: '',
      containerWidth: 0,
      slidesToShow: this.visualConfiguration.shownCards,
      slidesToScroll: 1,
      slidesGap: 16,
      slideExtra: 0.25,
    };
  },
  computed: {
    slides() {
      return this.cards.map((item, idx) => ({
        key: idx.toString(),
        props: {
          ...item,
        },
      }));
    },
    slideWidth() {
      // This method could will be removed when cedar16 Includes the Slider Component
      if (!this.containerWidth) return 0;

      const slidesGapTotal = (this.slidesToShow - 1) * this.slidesGap;
      const slidesWidthWithoutGaps = this.containerWidth - slidesGapTotal;
      const slidesToShowCount = this.slidesToShow + this.slideExtra;

      return slidesWidthWithoutGaps / slidesToShowCount;
    },
  },
  mounted() {
    const section = this.$el.closest('section[data-ui]');
    this.ui = section ? section.dataset.ui : '';
    this.updateContainerWidth();
    this.onResize();
    window.addEventListener('resize', this.onResize);
  },
  unmounted() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    updateContainerWidth() {
      // This method could will be removed when cedar16 Includes the Slider Component
      if (this.$refs.scrollCarousel) {
        const carouselElement = this.$refs.scrollCarousel.$el;
        if (carouselElement) {
          this.containerWidth = carouselElement.getBoundingClientRect().width;
        }
      }
    },
    onResize() {
      const clientWidth = window.innerWidth;
      this.updateContainerWidth();

      switch (true) {
        case clientWidth < Number(CdrBreakpointSm):
          this.slidesToShow = 1;
          this.slideExtra = 0.25;
          this.slidesGap = 16;
          break;
        case clientWidth < Number(CdrBreakpointMd):
          this.slidesToShow = 2;
          this.slideExtra = 0.5;
          this.slidesGap = 16;
          break;
        case clientWidth < Number(CdrBreakpointLg):
          this.slidesToShow = 3;
          this.slideExtra = this.cards?.length >= 4 ? 0.15 : 0;
          this.slidesGap = 24;
          break;
        default:
          this.slidesToShow = this.cards?.length >= 4 ? 4 : 3;
          this.slideExtra = 0;
          this.slidesGap = 24;
          break;
      }
    },
  },
};
</script>
<template>
  <div class="info-cards">
    <heading-section
      v-if="heading && heading?.heading?.text"
      :heading="heading.heading.text"
    />
    <scroll-carousel
      :id="ui"
      ref="scrollCarousel"
      class="info-cards__rail"
      :class="heading && heading?.heading?.text ? '' : 'no-heading'"
      :slides="slides"
      :slides-gap="slidesGap"
      :slides-to-show="slidesToShow"
      :slides-to-scroll="slidesToScroll"
      :slide-extra="slideExtra"
      :is-showing-arrows="false"
    >
      <template #slide="card">
        <info-card
          v-bind="card"
          :key="`info-card-${card.index}`"
          :palette="visualConfiguration.palette"
          :tabindex="card.href ? 0 : -1"
        />
      </template>
    </scroll-carousel>
  </div>
</template>
<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

.info-cards {
  :deep(.scroll-carousel__viewport) {
    --slide-width: v-bind(slideWidth);
    > div {
      @supports (-webkit-touch-callout: none) {
        padding-right: $cdr-space-one-x;
      }
    }
  }
  .no-heading {
    margin-top: $cdr-space-one-and-a-half-x;
  }
  &__rail{
    @include cdr-sm-mq-down{
      margin-left: -$cdr-space-one-x;
      width: calc(100% + $cdr-space-two-x);
    }
  }
}
</style>
